{
    "common": {
        "mon": "Δευ",
        "tue": "Τρί",
        "wed": "Τετ",
        "thu": "Πέμ",
        "fri": "Παρ",
        "sat": "Σάβ",
        "sun": "Κυρ",
        "jan": "Ιαν",
        "feb": "Φεβ",
        "mar": "Μάρ",
        "apr": "Απρ",
        "jun": "Ιούν",
        "jul": "Ιούλ",
        "aug": "Αύγ",
        "sep": "Σεπ",
        "oct": "Οκτ",
        "nov": "Νοέ",
        "dec": "Δεκ",
        "january": "Ιανουάριος",
        "february": "Φεβρουάριος",
        "march": "Μάρτιος",
        "april": "Απρίλιος",
        "may": "Μάιος",
        "june": "Ιούνιος",
        "july": "Ιούλιος",
        "august": "Αύγουστος",
        "september": "Σεπτέμβριος",
        "october": "Οκτώβριος",
        "november": "Νοέμβριος",
        "december": "Δεκέμβριος",
        "checkin": "Ελεγχος-Σε",
        "checkout": "Ελεγχος-Εξω",
        "room": "Δωμάτιο",
        "rooms": "Δωμάτια",
        "adult": "Ενήλικας",
        "adults": "Ενήλικες",
        "edit": "Επεξεργασία",
        "editCap": "ΕΠΕΞΕΡΓΑΣΙΑ",
        "delete": "Διαγραφή",
        "deleteCap": "ΔΙΑΓΡΑΦΗ",
        "localTime": "Τοπική Ώρα",
        "back": "ΠΙΣΩ",
        "home": "ΑΡΧΙΚΗ",
        "yes": "ΝΑΙ",
        "no": "ΟΧΙ",
        "left": "Απομένει",
        "hour": "Ώρα",
        "hours": "Ώρες",
        "night": "νύχτα",
        "nights": "νύχτες",
        "for": "για",
        "why": "Γιατί",
        "get": "Πάρτε",
        "more": "Περισσότερα",
        "agree": "ΣΥΜΦΩΝΩ",
        "disagree": "ΔΕΝ ΣΥΜΦΩΝΩ",
        "basedOn": "βάσει",
        "error": "Υπήρξε σφάλμα, δοκιμάστε ξανά αργότερα",
        "error2": "Αποτυχία, δοκιμάστε ξανά!",
        "error3": "Προέκυψε Σφάλμα!!",
        "error4": "Προέκυψε σφάλμα!! Παρακαλώ δοκιμάστε ξανά",
        "error5": "Λυπάμαι!! Προέκυψε κάποιο σφάλμα. Παρακαλώ δοκιμάστε ξανά σε λίγο.",
        "hi": "Γεια",
        "to": "προς",
        "free": "Δωρεάν",
        "per": "Ανά",
        "at": "στο",
        "day": "Ημέρα",
        "days": "Ημέρες",
        "time": "Ώρα",
        "of": "από",
        "photo": "Φωτογραφία",
        "photos": "Φωτογραφίες",
        "done": "Έγινε",
        "fullStay yarn": "Πλήρης διαμονή",
        "date": "Ημερομηνία",
        "and": "και",
        "bookingDetail": "Λεπτομέρειες Κράτησης",
        "Back": "Πίσω",
        "Home": "Αρχική"
    },
    "userPopup": {
        "myAccount": "Ο Λογαριασμός Μου",
        "welcome": "Καλώς ήρθατε",
        "user": "Χρήστης",
        "findMyBookings": "ΒΡΕΙΤΕ ΤΙΣ ΚΡΑΤΗΣΕΙΣ ΜΟΥ",
        "viewProfile": "ΠΡΟΒΟΛΗ ΠΡΟΦΙΛ",
        "makeAReservarion": "ΚΑΝΤΕ ΚΡΑΤΗΣΗ",
        "logout": "ΑΠΟΣΥΝΔΕΣΗ",
        "loginCap": "ΣΥΝΔΕΣΗ",
        "login": "Σύνδεση",
        "invalidCredentials": "Μη έγκυρα διαπιστευτήρια",
        "invalidEmail": "Μη έγκυρο Email",
        "passwordIsRequired": "Ο κωδικός απαιτείται",
        "minChar8": "ελάχιστα 8 χαρακτήρες",
        "tooShort": "Πολύ σύντομο!",
        "tooLong": "Πολύ μεγάλο!",
        "required": "Απαιτείται",
        "emailInvalid": "Εισάγετε έγκυρο email",
        "passwordInvalid": "Εισάγετε έγκυρο κωδικό",
        "phNumInvalid": "Ο αριθμός τηλεφώνου δεν είναι έγκυρος",
        "signupCap": "ΕΓΓΡΑΦΗ",
        "signup": "Εγγραφή",
        "verifyText": "Επιβεβαιώστε ότι είστε εσείς",
        "verifyText2": "Στείλαμε έναν κωδικό επαλήθευσης στο email σας",
        "verificationCode": "Κωδικός Επαλήθευσης",
        "didNotReceiveEmail": "Δεν λάβατε email",
        "clickToResend": "Κάντε κλικ για επαναποστολή",
        "verifyAndSignIn": "Επαληθεύστε και Συνδεθείτε",
        "otpSentSuccessfully": "Ο κωδικός στάλθηκε επιτυχώς",
        "somethingWentWrong": "Κάτι πήγε στραβά, παρακαλώ δοκιμάστε ξανά",
        "otpError": "Παρακαλώ εισάγετε έγκυρο αριθμό",
        "otpError2": "Παρακαλώ εισάγετε μόνο αριθμούς",
        "otpError3": "Εσφαλμένος κωδικός, παρακαλώ δοκιμάστε ξανά",
        "otpError4": "Ο κωδικός έληξε, κάντε κλικ στο Επαναποστολή για να δοκιμάσετε ξανά",
        "otpError5": "Παρακαλώ δοκιμάστε ξανά",
        "forgetPassword": "Ξέχασα τον Κωδικό",
        "submitError": "Ο χρήστης δεν υπάρχει!",
        "userExistError": "Ο Χρήστης Υπάρχει Ήδη",
        "checkYourEmail": "Ελέγξτε το email σας",
        "passwordResetLinkSent": "Στείλαμε έναν σύνδεσμο επαναφοράς κωδικού στο",
        "noWorriesResetInstructions": "Μην ανησυχείτε, θα σας στείλουμε οδηγίες επαναφοράς.",
        "enterYourEmail": "Εισάγετε το email σας",
        "resetMyPassword": "ΕΠΑΝΑΦΟΡΑ ΚΩΔΙΚΟΥ",
        "setANewPassword": "Ορίστε νέο κωδικό",
        "newPassword": "Νέος Κωδικός",
        "confirmPassword": "Επιβεβαίωση Κωδικού",
        "confirmPasswordError": "Οι κωδικοί πρέπει να ταιριάζουν",
        "backToLogin": "Επιστροφή στη Σύνδεση",
        "dontHaveAccount": "Δεν έχετε λογαριασμό;",
        "alreadyHaveAccount": "Έχετε ήδη λογαριασμό;",
        "memberDiscount1": "Θα λάβετε",
        "memberDiscount2": "έκπτωση μέλους για πάντα.",
        "discount1": "Διαχειριστείτε όλες τις Κρατήσεις σας από ένα μέρος.",
        "discount2": "Εγγραφείτε για εξατομικευμένες συστάσεις και προσαρμοσμένες εμπειρίες!!",
        "discount3": "Ελάτε στην κοινότητα των ευτυχισμένων επισκεπτών και ξεκινήστε να σχεδιάζετε τη διαμονή σας.",
        "leftGridText1": "Διαχειριστείτε όλες τις Κρατήσεις σας από ένα μέρος",
        "leftGridText2": "Εγγραφείτε για εξατομικευμένες συστάσεις και προσαρμοσμένες εμπειρίες!!",
        "leftGridText3": "Ελάτε στην κοινότητα των ευτυχισμένων επισκεπτών και ξεκινήστε να σχεδιάζετε τη διαμονή σας",
        "gridDiscountText1": "έκπτωση μέλους σε",
        "gridDiscountText2": "επιλεγμένες καταλυματικές μονάδες για πάντα",
        "gridDiscountText3": "Συνδεθείτε για εξατομικευμένη εμπειρία για πάντα",
        "gridDiscountText4": "Λάβετε Αποκλειστικά Οφέλη Μελών",
        "findBookingError": "Το email σας και το id κράτησης δεν ταιριάζουν",
        "verifyAndConfirmBooking": "Επαληθεύστε και επιβεβαιώστε την κράτηση",
        "confirmEmailText": "Στείλαμε έναν κωδικό επαλήθευσης στη διεύθυνση email σας",
        "enterCodeText": "Παρακαλώ εισάγετε τον κωδικό επαλήθευσης που σας στάλθηκε",
        "didNotRecieveEmail": "Δεν λάβατε email;",
        "changeEmailText": "Κάντε κλικ εδώ για να αλλάξετε τη διεύθυνση email",
        "verifyAndConfirm": "Επαληθεύστε και Επιβεβαιώστε",
        "verified": "ΕΠΑΛΗΘΕΥΜΕΝΟ",
        "bookingExpired": "Η Κράτηση Έληξε",
        "bookingExpiredText": "Λυπάμαι, το id κράτησης που χρησιμοποιείτε έληξε",
        "backToFindingBooking": "Πίσω στην Αναζήτηση Κράτησης",
        "findMyBooking": "Βρείτε τις Κρατήσεις Μου",
        "bookingEmail": "Email Κράτησης",
        "reservationId": "ID Κράτησης",
        "findBooking": "ΕΥΡΕΣΗ ΚΡΑΤΗΣΗΣ",
        "abandonmentCartDoneText1": "Ευχαριστούμε!",
        "abandonmentCartDoneText2": "Οι λεπτομέρειες του καλαθιού σας έχουν σταλεί στο email. Συνεχίστε την κράτησή σας ανά πάσα στιγμή.",
        "Recommended Currencies": "Προτεινόμενα Νομίσματα",
        "All currencies": "Όλα τα νομίσματα",
        "thisIsRequiredField": "Αυτό είναι απαιτούμενο Πεδίο"
    },
    "widget": {
        "destination": "Προορισμός",
        "enterDestination": "ΕΙΣΑΓΩΓΗ ΠΡΟΟΡΙΣΜΟΥ",
        "guests": "Επισκέπτες",
        "guest": "Επισκέπτης",
        "nationality": "Εθνικότητα",
        "selectNationality": "Επιλέξτε εθνικότητα",
        "nationalityIsRequired": "Η εθνικότητα είναι υποχρεωτική",
        "selectedRate": "Ειδική τιμή",
        "search": "Αναζήτηση",
        "ages": "Ηλικίες",
        "orAbove": "Ή Παραπάνω",
        "child": "Παιδί",
        "children": "Παιδιά",
        "addAnotherRoom": "Προσθήκη Άλλου Δωματίου",
        "removeRoom": "Αφαίρεση Δωματίου",
        "property": "Καταλυματική Μονάδα",
        "city": "Πόλη",
        "country": "Χώρα",
        "bookNow": "Κρατήστε Τώρα",
        "overnightStay": "Διανυκτέρευση",
        "dayUse": "Ημερήσια Χρήση",
        "destinationIsRequired": "Ο προορισμός είναι απαραίτητος",
        "checkInIsRequired": "Η ημερομηνία έναρξης είναι απαραίτητη",
        "checkOutIsRequired": "Η ημερομηνία λήξης είναι απαραίτητη",
        "noLocationFound": "Δεν Βρέθηκε Τοποθεσία",
        "soldOut": "Εξαντλήθηκε",
        "highDemand": "Υψηλή Ζήτηση",
        "dates": "Ημερομηνίες",
        "allRates": "Όλες οι τιμές είναι σε",
        "K": "K",
        "M": "M",
        "sameDayCheckout": "Αναχώρηση την ίδια ημέρα"
    },
    "promotion": {
        "headingText": "Σημαντικές Πληροφορίες για",
        "regularRate": "Καμία",
        "seniorCitizen": "Τιμή Ηλικιωμένων",
        "agencyRate": "Τιμή Πρακτόρων",
        "caaRate": "Τιμή CAA/AAA",
        "corporateRate": "Εταιρική Τιμή",
        "governmentRate": "Τιμή Κυβέρνησης/Στρατού",
        "promotionalSpecialRate": "Προωθητική/Ειδική Τιμή",
        "regularRateDescription": "Δεν εφαρμόστηκε καμία προώθηση.",
        "seniorCitizenRateDescription": "Αυτή είναι μια μειωμένη τιμή ξενοδοχείου που διατίθεται εκτενώς σε ηλικιωμένους, συνήθως ηλικίας 60+ ετών.",
        "agencyRateDescription": "Αυτή είναι μια μειωμένη τιμή ξενοδοχείου που προσφέρεται και μπορεί να προσπελαστεί μόνο μέσω συγκεκριμένων ταξιδιωτικών πρακτόρων, προάγοντας συνεργασία.",
        "caaRateDescription": "Αυτή είναι μια ειδική τιμή ξενοδοχείου που προσφέρεται σε μέλη του AAA ή CAA για αποκλειστικές εξοικονόμησεις.",
        "corporateRateDescription": "Αυτή είναι μια μειωμένη τιμή ξενοδοχείου που παραχωρείται σε επαγγελματίες ταξιδιώτες, συνήθως συζητημένη μεταξύ του ξενοδοχείου και της εταιρικής οντότητας.",
        "governmentRateDescription": "Αυτό το τιμολόγιο προσφέρει συγκεκριμένες εκπτώσεις για προσωπικό Κυβέρνησης/Στρατού για κράτηση ξενοδοχείου.",
        "contentSeniorCitizen": "Το πιστοποιητικό γέννησης είναι υποχρεωτικό κατά τη στιγμή της άφιξης. Η αποτυχία να παρουσιαστεί σχετικό ταυτοποιητικό θα έχει ως αποτέλεσμα τη χρέωση των υφιστάμενων τιμών.",
        "contentAgencyRate": "Βεβαιωθείτε ότι έχετε την επιβεβαίωση κράτησης και την απόδειξη ταυτότητάς σας κατά την άφιξη. Η αποτυχία να τα παρουσιάσετε θα έχει ως αποτέλεσμα την εφαρμογή τυπικών τιμών.",
        "contentPromotionalSpecialRate": "Αυτή είναι μια μειωμένη τιμή ξενοδοχείου που προσφέρεται για περιορισμένο χρόνο, συχνά συνδεδεμένη με συγκεκριμένα γεγονότα, εποχές ή μάρκετινγκ καμπάνιες.",
        "contentCaaRate": "Παρακαλώ βεβαιωθείτε ότι έχετε την κάρτα μέλους του CAA ή σχετική ταυτοποίηση κατά την άφιξη. Η αποτυχία να παρουσιαστεί σχετικό ταυτοποιητικό θα έχει ως αποτέλεσμα τη χρέωση των υφιστάμενων τιμών.",
        "contentCorporateRate": "Απόδειξη ταυτότητας εταιρείας ή άλλης επίσημης τεκμηρίωσης απαιτείται κατά την άφιξη. Η αποτυχία να παρουσιαστεί σχετική απόδειξη θα έχει ως αποτέλεσμα τη χρέωση των υφιστάμενων τιμών.",
        "contentGovernmentRate": "Πρέπει να παρουσιαστεί έγκυρο κυβερνητικό ή στρατιωτικό ταυτοποιητικό κατά την άφιξη. Η αποτυχία να παρουσιαστεί το απαιτούμενο ταυτοποιητικό θα έχει ως αποτέλεσμα τη χρέωση στην τυπική τιμή.",
        "CORP": "CORP",
        "AGEN": "AGEN",
        "PROM": "PROM",
        "apply": "ΕΦΑΡΜΟΓΗ",
        "Offer Code": "Κωδικός Προσφοράς",
        "Agency Code": "Κωδικός Πρακτόρων",
        "Corporate Code": "Εταιρικός Κωδικός",
        "All-Access Rate": "Τιμή Πλήρους Πρόσβασης",
        "errorCode": "Αυτός ο Κωδικός δεν είναι έγκυρος"
    }
}

